import {Component, Input, OnInit, forwardRef} from '@angular/core';
import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
  UntypedFormControl
} from '@angular/forms';
import {Stammdatum} from '../../dtos/stammdatum';
import {StammdatenService} from '../../services/stammdaten.service';

@Component({
  selector: 'app-dropdown',
  templateUrl: './tmst-dropdown.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      // eslint-disable-next-line @angular-eslint/no-forward-ref
      useExisting: forwardRef(() => TemostaDropdownComponent)
    }
  ],
  standalone: false
})
export class TemostaDropdownComponent implements OnInit, ControlValueAccessor {
  @Input() model: UntypedFormControl;
  @Input() key: string;
  @Input() allowMultiSelect = false;
  @Input() controlname = 'control';
  @Input() controlId: string;
  @Input() placeholder: string;
  items: Stammdatum[];

  constructor(private readonly stammdatenService: StammdatenService) {}

  ngOnInit() {
    if (this.key) {
      this.stammdatenService.data.subscribe(data => {
        this.items = data[this.key];
      });
    }
    this.model.valueChanges.subscribe(value => {
      this.propagateChange(value);
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-empty-function
  propagateChange = (_: any) => {};

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  writeValue(value: any): void {
    this.model.setValue(value);
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  registerOnTouched(): void {}
}
